import { useBankProfile } from '@contexts/BankProfileContext';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { useAuth } from './useAuth';

interface UnreadThreadsCount {
	count: number;
}

const FIVE_MINUTES = 5 * 60 * 1000;

export const useUnreadThreadsCount = () => {
	const { session } = useAuth();
	const { selectedProfile } = useBankProfile();

	const getUnreadThreadsCount = async (): Promise<number> => {
		const { data } = await axios.get<UnreadThreadsCount>(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/threads/unread`,
			{
				headers: { Authorization: session?.tokenized },
			},
		);

		return data?.count ?? 0;
	};

	return useQuery({
		queryKey: ['threads', 'unreadCount', selectedProfile?.id],
		enabled: Boolean(session?.tokenized && selectedProfile),
		queryFn: getUnreadThreadsCount,
		refetchInterval: FIVE_MINUTES,
		refetchOnWindowFocus: true,
		refetchOnReconnect: true,
	});
};
